webpackJsonp([114276838955818,60335399758886],{

/***/ 110:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(187);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(110);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(52);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _data = __webpack_require__(155);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _theme = __webpack_require__(23);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _config = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = _data2.default.name,
	    title = _data2.default.title,
	    description = _data2.default.description,
	    img = _data2.default.img,
	    url = _data2.default.url,
	    org = _data2.default.org,
	    event = _data2.default.event;
	
	
	var meta = function meta(tags) {
	  return tags.map(function (props, index) {
	    return _react2.default.createElement('meta', _extends({}, props, { key: index }));
	  });
	};
	var heap = '\n  window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=t.forceSSL||"https:"===document.location.protocol,a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src=(r?"https:":"http:")+"//cdn.heapanalytics.com/js/heap-"+e+".js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(a,n);for(var o=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],c=0;c<p.length;c++)heap[p[c]]=o(p[c])};\n  heap.load("3545039032");\n';
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _theme2.default,
	    { webfonts: true },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { title: title },
	      _react2.default.createElement('html', { lang: 'en' }),
	      _react2.default.createElement('meta', { charSet: 'UTF-8' }),
	      _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width,initial-scale=1' }),
	      _react2.default.createElement('meta', { name: 'format-detection', content: 'telephone=no' }),
	      _react2.default.createElement('link', { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }),
	      _react2.default.createElement('meta', { name: 'theme-color', content: _config.colors.primary }),
	      meta([{ name: 'description', content: description }, { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:description', content: description }, { name: 'twitter:domain', content: url }, { name: 'twitter:site', content: url }, { name: 'twitter:image', content: img }, { name: 'twitter:title', content: title }, { property: 'og:description', content: description }, { property: 'og:image', content: img }, { property: 'og:image:height', content: 576 }, { property: 'og:image:width', content: 576 }, { property: 'og:locale', content: 'en_US' }, { property: 'og:site_name', content: name }, { property: 'og:title', content: title }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: url }]),
	      _react2.default.createElement('link', { rel: 'stylesheet', href: '/fonts.css' }),
	      _react2.default.createElement('script', { type: 'application/ld+json', children: JSON.stringify(org) }),
	      _react2.default.createElement('script', { type: 'application/ld+json', children: JSON.stringify(event) }),
	      ("production") !== 'development' && _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: heap } })
	    ),
	    props.children()
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.colors = undefined;
	
	var _designSystem = __webpack_require__(4);
	
	var colors = exports.colors = {
	  // greyscale
	  black: '#1f2d3d',
	  steel: '#273444',
	  slate: '#3c4858',
	  muted: '#8492a6',
	  // smoke3: '#c0ccda',
	  // smoke2: '#d3dce6',
	  smoke: '#e0e6ed',
	  // snow3: '#e5e9f2',
	  // snow2: '#eff2f7',
	  snow: '#f9fafc',
	  white: '#ffffff',
	  // brand
	  primary: '#ff5a5f',
	  primaryLight: '#ff7e82',
	  primaryDark: '#e00007',
	  alt: '#007a87',
	  altLight: '#009aab',
	  altDark: '#004f58',
	  success: '#3fb34f',
	  error: '#b23f42',
	  warm: '#ffb400',
	  warmWash: '#ffdc89',
	  cool: '#00bdde',
	  coolWash: '#7cecff'
	  // for DS input
	};colors.blue = [colors.altDark, colors.altLight, colors.altLight];
	colors.info = colors.alt;
	
	_designSystem.theme.colors = colors;
	
	var baseFamily = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif';
	
	var sans = 'Sailec';
	var sansFamily = sans + ',' + baseFamily;
	
	_designSystem.theme.font = sansFamily;
	
	_designSystem.theme.styles = {
	  medium: { style: { fontWeight: 500 } },
	  headline: { f: [5, 6], color: 'black', style: { lineHeight: '1.125' } },
	  subhline: {
	    f: [3, 4],
	    color: 'black',
	    regular: true,
	    style: { lineHeight: '1.375' }
	  },
	  subtext: { f: [3, 4], color: 'black', style: { lineHeight: '1.5' } },
	  contentContainer: {
	    maxWidth: 64,
	    w: 1,
	    p: [3, 2],
	    style: { position: 'relative' }
	  },
	  content: { maxWidth: 48, mx: 0 }
	};
	
	exports.default = _designSystem.theme;

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.theme = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  * { box-sizing: border-box; }\n  body {\n    margin: 0;\n    font-family: ', ';\n    line-height: 1.5;\n  }\n  h2 {\n    line-height: 1.5 !important;\n  }\n  a {\n    box-shadow: none;\n    text-decoration: none;\n  }\n  ul, ol {\n    margin: 0;\n    padding: 0;\n  }\n  h1 + h2,\n  p > a,\n  b {\n    font-weight: 500 !important;\n  }\n  strong {\n    font-weight: 700 !important;\n  }\n'], ['\n  * { box-sizing: border-box; }\n  body {\n    margin: 0;\n    font-family: ', ';\n    line-height: 1.5;\n  }\n  h2 {\n    line-height: 1.5 !important;\n  }\n  a {\n    box-shadow: none;\n    text-decoration: none;\n  }\n  ul, ol {\n    margin: 0;\n    padding: 0;\n  }\n  h1 + h2,\n  p > a,\n  b {\n    font-weight: 500 !important;\n  }\n  strong {\n    font-weight: 700 !important;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _config = __webpack_require__(18);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var theme = exports.theme = _config2.default;
	
	(0, _styledComponents.injectGlobal)(_templateObject, _config2.default.font);
	
	var ThemeProvider = function ThemeProvider(props) {
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: _config2.default },
	    _react2.default.createElement(
	      _react.Fragment,
	      null,
	      props.children
	    )
	  );
	};
	
	exports.default = ThemeProvider;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-a4524b71ca29b0f91149.js